module.exports = __webpack_public_path__ + "static/media/refund-pending-orange-icon.80144909.svg";